// extracted by mini-css-extract-plugin
export var entityChip = "_sz-0";
export var entityChipMissing = "_sz-1";